export default "__VITE_ASSET__b02b0b82__"